import type { FormButtonSettingsFormType } from './sp-form-button-settings.type';

import { FormControl, FormGroup } from '@angular/forms';
import type { ThemeButtonHoverLegacy as ThemeButtonHover } from '@sites/entity-core';
import { type ThemedBaseButtonProp } from '@common/types/base-button-widget.type';

type FormButtonBaseSettingsFormType = {
    color?: FormControl<ThemedBaseButtonProp['color']>;
    background?: FormControl<ThemedBaseButtonProp['background']>;
    borderColor?: FormControl<ThemedBaseButtonProp['borderColor']>;
    borderWidth?: FormControl<ThemedBaseButtonProp['borderWidth']>;
    borderRadius?: FormControl<ThemedBaseButtonProp['borderRadius']>;
    borderStyle?: FormControl<ThemedBaseButtonProp['borderStyle']>;
};

type FormButtonHoverSettingsFormType = {
    hoverType?: FormControl<ThemeButtonHover['hoverType']>;
    opacity?: FormControl<ThemeButtonHover['opacity']>;
    shadow?: FormControl<ThemeButtonHover['shadow']>;
    color?: FormControl<ThemeButtonHover['color']>;
    background?: FormControl<ThemeButtonHover['background']>;
    borderColor?: FormControl<ThemeButtonHover['borderColor']>;
};

export const formButtonBaseSettingsForm = (): FormGroup<FormButtonBaseSettingsFormType> =>
    new FormGroup<FormButtonBaseSettingsFormType>({
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
        borderWidth: new FormControl(null),
        borderRadius: new FormControl(null),
        borderStyle: new FormControl(null),
    });

export const formButtonHoverSettingsForm = (): FormGroup<FormButtonHoverSettingsFormType> =>
    new FormGroup<FormButtonHoverSettingsFormType>({
        hoverType: new FormControl(null),
        opacity: new FormControl(null),
        shadow: new FormControl(null),
        color: new FormControl(null),
        background: new FormControl(null),
        borderColor: new FormControl(null),
    });

export type FormButtonBaseSettingsFormGroupType = FormGroup<FormButtonBaseSettingsFormType>;
export type FormButtonHoverSettingsFormGroupType = FormGroup<FormButtonHoverSettingsFormType>;

export const formButtonSettingsForm = (): FormGroup<FormButtonSettingsFormType> =>
    new FormGroup<FormButtonSettingsFormType>({
        size: new FormControl(null),
        label: new FormControl(null),
        styleType: new FormControl(null),
        buttonBase: formButtonBaseSettingsForm(),
        buttonHover: formButtonHoverSettingsForm(),
        widthType: new FormControl(null),
        horizontalFormWidthType: new FormControl(null),
        widthValue: new FormControl(null),
        buttonIcon: new FormControl(null),
        additionalEffects: new FormControl(null),
        isIndependentCorners: new FormControl(null),
        advancedRadius: new FormControl(null),
        advancedBorderSettings: new FormControl(null),
        isShadow: new FormControl(null),
        shadowSettings: new FormControl(null),
        isShowButton: new FormControl(null),
    });
